import { Component } from '@angular/core';
import { IncomeCategoryService } from '../income-category.service';
import { IncomeCategory } from '../income-category';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationService } from '../../shared/notification.service';

@Component({
  selector: 'app-income-category-edit',
  templateUrl: 'edit.component.html',
})
export class IncomeCategoryEditComponent {
  /**
   * Details of the incomeCategory being edited.
   */
  public incomeCategory: IncomeCategory;

  /**
   * Are we currently performing a loading action?
   *
   * @type {boolean}
   */
  public isLoading: boolean = false;

  /**
   * Load up all our required services and subscribe to every observable we need.
   *
   * @param {IncomeCategoryService} incomeCategoryService
   * @param {NotificationService} notificationService
   * @param {Router} router
   * @param {ActivatedRoute} route
   */
  constructor(
    private incomeCategoryService: IncomeCategoryService,
    private notificationService: NotificationService,
    private router: Router,
    private route: ActivatedRoute,
  ) {
    this.incomeCategoryService.loading.subscribe(
      result => (this.isLoading = result),
    );
    this.route.params.subscribe(params => this.loadIncomeCategory(params.id));
  }

  /**
   * Perform the edit action which send the edited incomeCategory to the backend.
   */
  public edit() {
    const editIncomeCategory = this.incomeCategoryService
      .updateIncomeCategory(this.incomeCategory.id, this.incomeCategory)
      .subscribe(
        (result: IncomeCategory) => {
          this.notificationService.success(
            `IncomeCategory Updated`,
            `The incomeCategory ${
              result.name
            } been updated with the specified changes.`,
            5,
          );
          this.incomeCategory = new IncomeCategory();
          editIncomeCategory.unsubscribe();
          this.router.navigate(['/income-categories']);
        },
        err => {
          this.notificationService.error(
            `IncomeCategory Not Found`,
            err.error.message,
            10,
          );
          this.router.navigate(['/income-categories']);
        },
      );
  }

  /**
   * Loads the requested incomeCategory so we can display it and let the user edit the fields.
   *
   * @param {string} id
   */
  private loadIncomeCategory(id: string) {
    this.incomeCategoryService.findIncomeCategory(id).subscribe(
      result => {
        this.incomeCategory = result;
      },
      err => {
        this.notificationService.error(
          `IncomeCategory Not Found`,
          err.error.message,
          10,
        );
        this.router.navigate(['/income-categories']);
      },
    );
  }
}
